import React from 'react';
import PropTypes from 'prop-types';

import { USD } from 'helpers/formatters/number_formats';

export default function UncollectedAmountRow({ receivable }) {
  return (
    <tr>
      <td>{receivable.invoiceIdentifiers.join(', ') || '--'}</td>
      <td>{receivable.date}</td>
      <td>{USD.format(receivable.totalCommission)}</td>
      <td>{USD.format(receivable.amountPaid)}</td>
      <td>{USD.format(receivable.amountUnpaid)}</td>
    </tr>
  );
}

UncollectedAmountRow.propTypes = {
  receivable: PropTypes.shape({
    amountPaid: PropTypes.number,
    amountUnpaid: PropTypes.number,
    date: PropTypes.string,
    invoiceIdentifiers: PropTypes.arrayOf(PropTypes.string),
    totalCommission: PropTypes.number,
  }).isRequired,
};
